import React from 'react';

function WCLogo() {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.0569 34.1138C26.4772 34.1138 34.1138 26.4772 34.1138 17.0569C34.1138 7.63663 26.4772 0 17.0569 0C7.63663 0 0 7.63663 0 17.0569C0 26.4772 7.63663 34.1138 17.0569 34.1138Z" fill="white"/>
      <path d="M24.742 10.9639L23.0173 11.8357L24.9599 15.266L26.6846 14.3942L24.742 10.9639Z" fill="url(#paint0_linear_1810_860)"/>
      <path d="M16.6684 10.8121L14.9437 11.6839L21.6622 25.0925L23.3869 24.2208L16.6684 10.8121Z" fill="#1A1B1E"/>
      <path d="M7.07861 11.8356L13.7971 25.2442L15.6355 24.3061L8.91697 10.8975L7.07861 11.8356Z" fill="#1A1B1E"/>
      <defs>
        <linearGradient id="paint0_linear_1810_860" x1="23.018" y1="13.1132" x2="26.6813" y2="13.1132" gradientUnits="userSpaceOnUse">
          <stop stopColor="#01ADF9"/>
          <stop offset="1" stopColor="#405CFF"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default WCLogo;
